import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import layoutContext from "../../../context/LayoutContext";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import features from "./../../../assets/features/ride-height.jpg";
import ezfit from "./../../../assets/features/ezifit-rear.jpg";
import schocks from "./../../../assets/features/foam-cell-shock.jpg";
import air from "./../../../assets/features/air-assist.jpg";
import hunter from "./../../../assets/features/hunter.jpg";

const Features = () => {
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText("Informacje Techniczne");
  }, []);

  return (
    <StyledFeatures>
      <Container>
        <UnderlinedHeader text={"INFORMACJE TECHNICZNE"} bolder />
        <Section>
          <p>
            Witamy na stronie działu technicznego. Stworzyliśmy ją aby pomóc
            Tobie zrozumieć jak działa zawieszenie w Twoim samochodzie, jak je
            naprawiać i modyfikować.
          </p>
          <p>
            Pedders jest wyspecjalizowanym producentem układów zawieszenia i
            układów hamulcowych, skoncentrowanym się na rozwiązywaniu problemów,
            takich jak naprawa zawieszenia, transport większych ładunków,
            poprawa jakości jezdnych oraz eliminowanie słabych punktów w
            niektórych pojazdach.
          </p>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Wysokość pojazdu:</Header>
              <p>
                W przypadku wielu pojazdów Pedders oferuje podnoszące lub
                obniżające sprężyny. Tradycyjnie mówi się o obniżeniu (lub
                podwyższaniu), powiedzmy, 30 mm. Mogłoby to być przydatne, jeśli
                zakłada się, że pojazd jest na właściwej wysokości. Jednak dość
                często kupuje się zestaw obniżających o teoretycznie 30 mm,
                instaluje się go po czym okazuje się, że powstały spadek nie
                wynosi 30 mm. Wynika to oczywiście z faktu, że pojazd albo z
                czasem osiadł na swoich sprężynach, albo miał już wymienione
                sprężyny wcześniej i nie był na standardowej wysokości.
              </p>
              <p>
                Aby uniknąć takiego rozczarowania, w większości przypadków
                będziemy odnosić się do określonej wysokości montażu. Wymiary
                podajemy zgodnie z pokazanym schematem. Tak więc, niezależnie od
                aktualnej wysokości pojazdu, wysokość z zamontowanymi nowymi
                sprężynami będzie taka jak tu podana.
              </p>
              <p>
                Oczywiście należy wziąć pod uwagę, że na ostateczny wynik mogą
                wpływać inne czynniki, z których najważniejszym jest ewentualna
                dodatkowa waga pojazdu. Podane przez nas wysokości dotyczą
                standardowego, nie obciążonego pojazdu. Jeśli w Twoim pick-upie
                znajduje się pół tony „ładunku” lub został wymieniony na inny
                typ silnika, to wynik może być zupełnie inny! Jeśli masz właśnie
                taką sytuacje, skontaktuj się z nami, ponieważ możemy mieć dla
                Ciebie rozwiązanie.
              </p>
            </div>
            <Flex>
              <StyledImg src={features} alt={"Wysokość pojazdu"} />
              <Centered>
                Należy zauważyć, że podana wysokość będzie wynosić np. „745 mm z
                kołami 16”. To jest referencyjny rozmiar koła. NIE oznacza to,
                że nie możesz dopasować zawieszenia do pojazdu, ponieważ ma
                17-calowe koła.
              </Centered>
            </Flex>
          </Grid>
        </Section>
        <Section>
          <Grid>
            <Flex>
              <StyledImg
                alt={"Sprężyny i amortyzatory. Za co są odpowiedzialne?"}
                src={ezfit}
              />
              <Centered>
                803040. Pedders Ezifit Rear Suspension Conversion Kit. For
                Subaru Forester
              </Centered>
            </Flex>
            <div>
              <Header>Sprężyny i amortyzatory. Za co są odpowiedzialne?</Header>
              <p>
                Często spotykamy się ze złym zrozumieniem funkcji zarówno
                sprężyn, jak i amortyzatorów.
              </p>
              <p>
                Sprężyny podtrzymują ciężar pojazdu, tj. utrzymują go nad
                ziemią.
              </p>
              <p>
                Amortyzatory kontrolują i tłumią wstrząsy pojazdu. Wstrząsy nie
                zmieniają i nie mogą zmieniać jego wysokości. Jest oczywiście
                wyjątek, a mianowicie system samopoziomowania Nivomat montowany
                między innymi w Subaru Forester, BMW X5, Hyundai Sant-fe i Kia
                Sorento. W tych pojazdach amortyzator przejmuje część ciężaru
                pojazdu, ale TYLKO część. Tak więc słabsza sprężyna jest
                wspierana przez amortyzator, który wspomaga ją przejmując część
                ciężaru pojazdu. Oznacza to, że gdy pojazd jest obciążony
                większą masą, amortyzator może zareagować na ten dodatkowy
                ciężar, zapewniając, że pojazd pozostaje na bezpiecznej,
                nieprzeładowanej wysokości. Amortyzator osiąga to wykorzystując
                ruch pojazdu do „pompowania” jego samego do pierwotnej
                wysokości. Amortyzator w tej pracy jest całkowicie
                samowystarczalny sam w sobie. Nie ma tam żadnych wężyków ani
                przewodów. Choć niewątpliwie rozwiązanie to jest bardzo sprytne
                i efektywne podczas pracy, może zawieść i zawodzi, czego efektem
                są tylne siedzenia pojazdu NIŻSZE niż powinny być. Często brak
                jakichkolwiek elementów zewnętrznych prowadzi do zastąpienia ich
                konwencjonalnymi amortyzatorami, co nie rozwiązuje problemu z
                objawami „niskiego siedzenia”.
              </p>
              <p>
                Pedders jest świadomy tego problemu i dla wielu pojazdów
                wyposażonych w systemy samopoziomowania Nivomat produkuje
                „zestawy” umożliwiające przejście na konwencjonalne zawieszenie
                co jest znacznie bardziej ekonomicznym rozwiązaniem niż wymiana
                amortyzatorów Nivomat na podobne zamienniki.
              </p>
              <p>
                Bez amortyzatorów pojazd na wybojach nadal odbijałby się jeszcze
                długo po przejechaniu przez nierówność.
              </p>
              <p>
                Oczywiście zarówno amortyzatory, jak i sprężyny wpływają na
                zachowanie się pojazdu na drodze i są ze sobą powiązane. Jest to
                temat złożony, ale z powodzeniem można znaleźć wiele publikacji
                na ten temat.
              </p>
            </div>
          </Grid>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Amortyzatory</Header>
              <p>
                W wielu przypadkach Pedders oferuje kilka różnych amortyzatorów
                dla danego modelu auta. Zastanawiasz się dlaczego?
              </p>
              <p>
                Producent projektując pojazd musi dokonać wyboru, jakie
                dokładnie funkcje ma spełnia amortyzator. Jeśli weźmiemy
                samochód typu pick-up, taki jak Toyota Hilux, może on być
                używany w dowolny sposób: od pustego do całkowicie załadowanego
                (obciążenie 1000 kg). Jest to bardzo szeroki zakres, a
                amortyzator będzie zaprojektowany tak, aby działał z optymalną
                wartością gdzieś pośrodku tego zakresu. W innym przypadku
                kompromis jest dopuszczalny ale do pewnego stopnie. Tam, gdzie
                są różne modele, na przykład Audi A6, model podstawowy będzie
                miał zamontowane bardziej miękkie amortyzatory niż wersja RS6
                tego samego samochodu.
              </p>
              <p>
                Pedders są w stanie zaoferować amortyzatory zaprojektowane tak,
                aby osiągnąć różne cele w zależności od sposobu użytkowania
                pojazdu. Na przykład w opisanym powyżej pick-upie możemy
                zaoferować amortyzator, który będzie działał z pełną mocą, gdy
                jest w pełni obciążony, dzięki czemu kierowca doświadczy
                lepszej, stabilniejszej jazdy niż standardowy amortyzator.
                Podobnie, jeśli pojazd jest używany przez cały czas bez ładunku,
                możemy zaoferować amortyzator, który sprawi, że pojazd będzie
                bardziej komfortowy niż z seryjnym amortyzatorem.
              </p>
              <p>
                Podobnie w przypadku samochodu osobowego, aby poprawić
                prowadzenie i osiągi, możemy zaprojektować amortyzator
                specjalnie do tego celu.
              </p>
              <p>
                Dzięki różnym wariantom Pedders może osiągnąć pożądany cel przy
                znacznie mniejszych kompromisie niż standardowe amortyzatory.
                Jest to możliwe dzięki zaawansowanym technikom projektowania
                amortyzatorów.
              </p>
              <p>
                Aby uzyskać więcej informacji na temat amortyzatorów i ich
                działania, obejrzyj poniższe filmy:
              </p>
            </div>
            <Flex>
              <StyledImg src={schocks} alt={"Amortyzatory"} />
              <Centered>
                153226. Amortyzator Pedders Foam Cell. Zaprojektowany dla
                większego komfortu jazdy. Dla Toyota Hilux MK7
              </Centered>
            </Flex>
          </Grid>
          <Grid>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/d2Qtkvdc7Pc"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/uKjltW4e6X8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Grid>
        </Section>
        <Section>
          <Header>Sprężyny</Header>
          <p>
            Sprężyny występują w różnych formatach: sprężyn, resorów, drążków
            skrętnych, poduszek powietrznych. Wszystkie są tak zwanymi
            sprężynami. Jak wspomniano wyżej, podtrzymują one ciężar pojazdu i
            kontrolują jego wysokość.
          </p>
          <p>
            Jeśli chcesz obniżyć pojazd, poprawić jego właściwości jezdne,
            przetransportować większy ładunek lub holować ciężką przyczepę, może
            być konieczna zmiana sprężyn, aby dostosować pojazd do określonego
            celu.
          </p>
          <p>
            Podobnie jak w przypadku szerokiej gamy amortyzatorów, w wielu
            przypadkach Pedders oferuje więcej niż jedną wersję sprężyn dla
            danego modelu pojazdu, w szczególności dla aut użytkowych, takich
            jak samochody dostawcze i pick-upy.
          </p>
          <p>
            Ponownie, pozwala nam to zapewnić najlepsze rozwiązanie dostosowane
            do sposobu użytkowania pojazdu. Szczególnie w przypadku pojazdów
            użytkowych należy wziąć pod uwagę, że bardzo wytrzymała sprężyna,
            która dobrze radzi sobie z dużymi obciążeniami, zapewni mniejszą niż
            pożądaną jakość komfortu jazdy bez obciążenia. Nie zawsze tak jest w
            przypadku każdej sprężyny wzmocnionej. W naszych opisach odnosimy
            się do minimalnego obciążenia w pojeździe, aby zapewnić akceptowalny
            poziom komfortu jazdy.
          </p>
          <Grid>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1thpHRHAp8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/m_ZvsNOUxTg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Grid>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Poduszki powietrzne</Header>
              <p>
                Chociaż „stalowe” sprężyny mogą często być rozwiązaniem dla aut
                transportujących ładunki, są również sytuacje, w których może to
                nie być najlepszym rozwiązaniem.
              </p>
              <p>
                Dzieję się tak przede wszystkim wtedy, gdy wahania obciążenia są
                duże i częste oraz gdy wzmocniona sprężyna nie byłaby
                odpowiednia dla jazdy bez obciążenia.
              </p>
              <p>
                Systemy poduszek powietrznych Pedders Air Assist są dostosowane
                do opisanej sytuacji. Poduszki mogą zostać opróżnione, co
                pozwala zawieszeniu pojazdu na normalną pracę, ale gdy
                przewożone są ciężkie ładunki, poduszki powietrzne są
                napompowane, aby pomóc istniejącemu zawieszeniu w transporcie
                ładunku.
              </p>
              <p>
                Większość dostępnych na rynku zestawów poduszek powietrznych
                wymaga napompowania przez sprężarkę. Tę samą, którą
                wykorzystujemy do pompowania opon. Jednak może się zdarzyć, że
                nie ma do zastosowania do wszystkich typów poduszek. Istnieje
                możliwość zainstalowania powietrza „na pokładzie”, dzięki czemu
                napełnianie i opróżnianie worka może odbywać się gdziekolwiek
                jesteś. Jest to dodatkowy zestaw, który można kupić.
              </p>
              <p>
                Rozważając rozwiązanie dla swojego auta jakim są poduszki
                powietrznej, zawsze pamiętaj, że jej funkcją jest wspomaganie
                zawieszenia pojazdu, a nie jego wymiana.
              </p>
            </div>
            <Flex>
              <StyledImg src={air} alt={"Poduszki powietrzne"} />
              <Centered>
                494060. Zestaw Pedders Air Assist dla Mitsubishi L200
              </Centered>
            </Flex>
          </Grid>
        </Section>
        <Section>
          <Header>Montaż</Header>
          <p>
            Większość naszych zestawów jest łatwa w montażu. O ile nie określono
            inaczej, wymiana na części Pedders przebiega zgodnie z opisem w
            odpowiedniej instrukcji pojazdu.
          </p>
          <p>
            Jednak w niektórych przypadkach, gdy dopasowanie różni się od
            oryginału lub konieczne jest wprowadzenie innych zmian, odpowiednie
            instrukcje są dołączone do zestawu.
          </p>
          <p>
            Nie możemy tutaj opisać wszystkich możliwych problemów, które możesz
            napotkać podczas montażu zawieszenia. Jeśli nie masz pewności,
            zaleca się montaż w profesjonalnym warsztacie.
          </p>
          <p>
            Do każdego zestawu dołączony jest broszura ze wskazówkami
            dotyczącymi montażu. Obejmuje ona szereg tematów, ale jeden z nich
            zasługuje na wzmiankę w tym miejscu, a mianowicie montaż elementów z
            tulejami.
          </p>
          <p>
            W przypadku zawieszenia z zamontowaną tuleją, która podlega ruchowi
            obrotowemu, tj. amortyzator lub dolny wahacz, NIE należy dokręcać
            śruby zabezpieczającej, dopóki pojazd nie znajdzie się na normalnej
            wysokości. Dokręcenie jej, gdy pojazd jest nad ziemią, może
            spowodować usterkę.
          </p>
          <p>
            Tuleje absorbują ruch obrotowy wywołany działaniem zawieszenia
            poprzez „skręcenie” gumy. Guma może to zrobić tylko do pewnego
            momentu. Jeśli śruba jest dokręcana, gdy pojazd znajduje się nad
            ziemią, gdy pojazd jest opuszczany na ziemię, nawet nieruchomo,
            tuleja będzie już znacznie „skręcona”. Gdy pojazd przejedzie przez
            nierówność, nastąpi dalsze skręcanie.
          </p>
          <p>
            Tuleja przy odpowiedniej wysokości pojazdu nie powinna być
            naprężona, aby mogła poruszać się w obie strony zgodnie z
            przeznaczeniem bez ryzyka uszkodzenia. Prawdopodobieństwo usterki
            zależy oczywiście od zakresu ruchu, któremu podlega, i będzie się
            różnić w zależności od pozostałych elementów i pojazdu.
          </p>
          <p>
            Warto również zauważyć, że to samo dotyczy opuszczania lub
            podnoszenia pojazdu. Wszelkie tuleje przegubów, nawet jeśli w inny
            sposób nie są naruszone, należy poluzować i ponownie dokręcić w
            momencie gdy pojazd jest już na odpowiedniej, żądanej wysokości.
          </p>
          <p>
            Jeśli nie zastosujesz się do powyższych wskazówek, poza możliwą
            wcześniejszą usterką, spowoduje to pewien stopień szorstkości przy
            manewrach, lub w niektórych przypadkach, takich jak Chrysler 300C,
            uniemożliwi osadzenie pojazdu na prawidłową jego wysokość.
          </p>
        </Section>
        <Section>
          <Grid>
            <div>
              <Header>Geometria koła</Header>
              <p>Jest to bardzo szeroki temat!</p>
              <p>
                Jednak starając się go uprościć, rozważ następujące kwestie.
              </p>
              <p>
                Jeśli zmieniasz wysokość pojazdu, absolutnie konieczne jest
                sprawdzenie i skorygowanie ustawienia kół. Niewykonanie tego w
                pewnym stopniu wpłynie na sposób prowadzenia pojazdu oraz
                szybsze zużyje opon.
              </p>
              <p>
                Zdecydowanie zalecamy sprawdzenie geometrii po zamontowaniu
                nowych elementów zawieszenia, które mogłyby wpłynąć na zbieżność
                kół. Jest bardzo wiele zmiennych, które mogą ale nie muszę na
                geometrię. Nie sposób wszystkie je tutaj opisać.
              </p>
              <p>
                Aby uzyskać więcej informacji na temat geometrii kół, obejrzyj
                poniższy film:
              </p>
              <iframe
                width="100%"
                height="300"
                src="https://www.youtube.com/embed/LJIolPrh_fE"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div>
              <StyledImg src={hunter} alt={"Geometria koła"} />
            </div>
          </Grid>
        </Section>
        <Section>
          <Header>Wybór odpowiednich części</Header>
          <p>
            Na naszej stronie internetowej dla wielu pojazdów można znaleźć
            „zestawy” zawieszenia. Utworzyliśmy je w oparciu o nasze
            doświadczenie w zakresie, co jest zwykle wymagane dla danego
            pojazdu.
          </p>
          <p>
            Jednak w przypadku, gdy nie jesteś pewien, czy są one odpowiednie
            lub już wiesz, że nie są odpowiednie dla Twoich potrzeb, nadal
            możemy Ci pomóc. W przypadku niektórych pojazdów występujących w tak
            wielu wersjach nie możemy wymienić wszystkich możliwości, dlatego
            prosimy o kontakt, a nasz doświadczony zespół z przyjemnością pomoże
            w znalezieniu odpowiedniego rozwiązania.
          </p>
        </Section>
      </Container>
    </StyledFeatures>
  );
};

export default Features;

const StyledFeatures = styled.section`
  padding-top: 30px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  line-height: 1.66;
`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 500px;
  height: auto;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Centered = styled.p`
  text-align: center;
`;

const Section = styled.div`
  border-bottom: 1px solid #666;
  margin: 20px 0;
  padding: 20px 0;
`;

const Header = styled.h2`
  font-weight: 600;
  margin: 20px 0;
  padding: 5px 0;
  border-bottom: 2px solid #dc3332;
  width: 100%;
  font-size: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
`;
